import React, {
  useEffect, useContext, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';
import { WinManagerContext } from '../../providers';

function LinkComp({
  component, title, leftToolBar,
}) {
  const {
    addComponentToWindowsManager, linkComponents, currentURL, switchWindow,
  } = useContext(WinManagerContext);
  const url = useLocation();
  const routerProps = useRef({});
  routerProps.current = useParams();
  if (!component) {
    // eslint-disable-next-line no-console
    console.error(`Unknow component on ${title}`);
  }

  useEffect(
    () => {
      const cc = linkComponents.filter((l) => l.url === url.pathname);
      if (cc.length) {
        if (currentURL !== url.pathname) {
          switchWindow(url.pathname);
        }
      } else {
        addComponentToWindowsManager(
          component,
          url.pathname,
          title,
          { ...routerProps.current, url: url.pathname, leftToolBar },
        );
      }
    },
    [addComponentToWindowsManager, component, currentURL, leftToolBar,
      linkComponents, switchWindow, title, url.pathname],
  );
  return (
    <div className="d-none">{title}</div>
  );
}

LinkComp.propTypes = {
  component: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  leftToolBar: PropTypes.bool,
  props: PropTypes.shape({}),
};

LinkComp.defaultProps = {
  component: null,
  leftToolBar: false,
  props: {
  },
};

export default LinkComp;
